module.exports = __webpack_public_path__ + "img/logo_en.15af5f11.png";